import { setBudgetItems } from "../set/setBudgetItems";
import { graphQLFetch } from "../../../utils";
import { GET_BUDGET_ITEMS } from "../../queries";

export const getBudgetItems =
  ({ pId, cId }, callback) =>
  async (dispatch, getState) => {
    const data = await graphQLFetch(
      GET_BUDGET_ITEMS,
      { pId, cId },
      "query",
      getState
    );
    const { GetBudgetItems } = data || {};

    if (callback && typeof callback === 'function') {
      callback(GetBudgetItems);
    }

    return dispatch(setBudgetItems(GetBudgetItems || []));
  };
